import React from "react";
import { formatMessage } from "lib/globalize-util";
import { AlertDialog } from "@nuorder/components";
interface IOwnProps {
    onOk: () => void;
    open: boolean;
    itemLimit: number;
    itemType: string;
}

export const MaxtItemsDialog: React.FunctionComponent<IOwnProps> = ({ open, itemLimit, onOk, itemType }) => {
    return (
        <AlertDialog
            width={420}
            open={open}
            onOk={onOk}
            title={formatMessage("Limit Reached")}
            message={formatMessage("You have reached the maximum number of |limit| |type|", {
                limit: itemLimit,
                type: itemType,
            })}
            okLabel={formatMessage("Ok")}
            closeButtonAriaLabel={formatMessage("Close")}
        />
    );
};
